import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';

import { CART_ITEM_LIST_BLOCK_COMPONENT } from '@core/services/cb2-preview/cb2-preview-bloc-types';
import { previewScenarioData } from '@core/services/cb2-preview/preview-scenario-data.util';
import { previewScenarioForBloc$ } from '@core/services/cb2-preview/preview-scenario-for-bloc.util';
import type { CartItemListBlockScenarioContent } from '@front-platform/content-builder';
import {
  CART_ITEM_LIST_BLOCK_LOADING_VM,
  CartItemListBlockDataSource,
  CartItemListBlockViewModel,
} from './cart-item-list-block-view-model';

function toCartItemListPreviewViewModel(
  content: CartItemListBlockScenarioContent,
): CartItemListBlockViewModel {
  return {
    reconstructedCart: content.reconstructedCart
      ? (content.reconstructedCart as unknown as CartItemListBlockViewModel['reconstructedCart'])
      : undefined,
    isOrderValidationInProgress: content.isOrderValidationInProgress,
  };
}

@Injectable()
export class CartItemListBlockPreviewDataSource implements CartItemListBlockDataSource {
  readonly vm$: Observable<CartItemListBlockViewModel> = previewScenarioForBloc$(
    CART_ITEM_LIST_BLOCK_COMPONENT,
  ).pipe(
    map(scenario => {
      if (!scenario) {
        return CART_ITEM_LIST_BLOCK_LOADING_VM;
      }
      const content = previewScenarioData<CartItemListBlockScenarioContent>(
        scenario,
        CART_ITEM_LIST_BLOCK_COMPONENT,
      );
      return content ? toCartItemListPreviewViewModel(content) : CART_ITEM_LIST_BLOCK_LOADING_VM;
    }),
  );
}
